function responsive_logo() {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        document.querySelector('#nav-logo').classList.remove('hover');
    } else {
        document.querySelector('#nav-logo').classList.add('hover');
    }
}

let nav_toggle = document.querySelector('#mobile-nav-toggle');
let nav_toggle_target = document.querySelector(nav_toggle.getAttribute('data-target'));

function check_mobile_nav() {
    // console.log(window.innerWidth);
    if (window.innerWidth !== undefined && window.innerWidth < 768) {
        nav_toggle_target.style.display = 'none';
        window.onscroll = false;
    } else {
        nav_toggle_target.style.display = 'block';
        window.onscroll = function() {responsive_logo()};
    }
}
check_mobile_nav();
window.addEventListener('resize', check_mobile_nav);

nav_toggle.addEventListener('click', function (event) {
    if (nav_toggle_target.style.display == 'block') {
        nav_toggle_target.style.display = 'none';
    } else {
        nav_toggle_target.style.display = 'block';
    }
});

// Register service worker
if ('serviceWorker' in navigator) {
    // console.log("Will the service worker register?");
    navigator.serviceWorker.register('/service-worker.js')
        .then(function (reg) {
            // console.log("Yes, it did.");
        }).catch(function (error) {
            // console.log("No it didn't. This happened: ", error)
    });
}
